import axios, { type InternalAxiosRequestConfig } from "axios";
import createAxiosInstance from "@/api/config/createAxiosInstance";
import { getCookie, setCookie } from "@/utils/cookies";
import { COOKIE_NONCE } from "@/constants/common";
import { VITE_MODES } from "@shared/config/constants";
import { WOO_STORE_API_PATH, WOO_STORE_API_PATH_PROXY } from "@/constants/env";

const { VITE_WP_SITE_DOMAIN, MODE } = import.meta.env;

const baseURL =
  MODE === VITE_MODES.LOCAL
    ? `${WOO_STORE_API_PATH_PROXY}`
    : `${VITE_WP_SITE_DOMAIN}${WOO_STORE_API_PATH}`;

const fetchNonceFromApi = async () => {
  try {
    const response = await axios.get(`${baseURL}/v1/cart/items`); // best to use a custom get nonce api
    const nonce = response.headers["nonce"];
    if (nonce) {
      const expiresDate = new Date(Date.now() + 12 * 60 * 60 * 1000); // 12H
      setCookie(COOKIE_NONCE, nonce, expiresDate);
    }
    return nonce;
  } catch (error) {
    throw error;
  }
};

const getValidNonce = async () => {
  let nonce = getCookie(COOKIE_NONCE);
  if (!nonce) {
    try {
      nonce = await fetchNonceFromApi();
    } catch (error) {
      throw error;
    }
  }
  return nonce;
};

const handleRequestConfig = async (config: InternalAxiosRequestConfig) => {
  if (config.url?.includes("/cart") || config.url?.includes("/checkout")) {
    const nonce = await getValidNonce();
    config.headers["Nonce"] = nonce;
    config.withCredentials = true;
  }

	// 針對購物車 & 結帳 API 設定更長的 timeout
	if (config.url?.includes("/cart") || config.url?.includes("/checkout")) {
		config.timeout = 30000;
	}
	
  return config;
};

const wooStoreApi = createAxiosInstance(baseURL, handleRequestConfig);

export { wooStoreApi };
